/**
 * Created by jonas on 2022-06-15.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";

export class NinjaSplashView extends PIXI.Container implements StageLayer{
    private _banner:PIXI.Sprite;
    private _view:PIXI.Container;
    private _animation:TimelineSprite;

    constructor() {
        super();
        this.name = "NinjaSplashView";
        this.init();
    }

    private init() {
        this._view = new PIXI.Container();

        this._animation = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures("ninjaWildSplashScreen"));
        this._animation.anchor.set(0.5,0.5);
        this._animation.position.set(360,300);
        this.addChild(this._animation);
        this.hide();

        this.onResize();
    }

    onResize():void {
    }


    public show():gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(()=>{
            this._animation.setFrame(0);
            this._animation.visible = true;
        });
        tl.add(this._animation.getAnimation());
        tl.add(this.hide());
        return tl;
    }

    public hide():gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(()=>{
            this._animation.visible = false;
        });
        return tl;
    }


}